import { grey, lightGreen, purple } from '@material-ui/core/colors';
import { SearchInventoryPoliciesResponseType } from 'features/orderManagement/types';

export function* getMemberNames<T extends Record<string, string | number>>(enumType: T): IterableIterator<string> {
  for (const enumMember in enumType) {
    if (Number.isNaN(Number(enumMember))) {
      yield enumMember;
    }
  }
}

function getColorFromHex(hexColor: string): number {
  return parseInt(hexColor.replace('#', '0x'));
}

export enum PolicyStatusColor {
  Open = getColorFromHex(lightGreen[600]),
  Void = getColorFromHex(purple[600]),
  Remitted = getColorFromHex(grey[600]),
}

export function getColorsByPolicyStatus(): { [status: string]: string } {
  const colors: { [status: string]: string } = {};
  const policyStatusColors = getMemberNames(PolicyStatusColor);
  let policyStatusColor = policyStatusColors.next();
  while (!policyStatusColor.done) {
    const colorCode = PolicyStatusColor[policyStatusColor.value as keyof typeof PolicyStatusColor];
    colors[policyStatusColor.value] = '#' + colorCode.toString(16).padStart(6, '0');
    policyStatusColor = policyStatusColors.next();
  }
  return colors;
}

export const canVoidPolicy = (policy: SearchInventoryPoliciesResponseType): boolean => {
  const isVirtualPolicy = policy.FileNo === null;
  if (policy.PolicyStatus === 'Void' || policy.PolicyStatus === 'Virtual Policy Void') return false;
  if (policy.PolicyStatus === 'Remitted') return false;
  if (isVirtualPolicy && policy.PolicyStatus === 'Virtual Policy Assigned') return false;
  return true;
};

export const canUnvoidPolicy = (policy: SearchInventoryPoliciesResponseType): boolean => {
  return policy.PolicyStatus === 'Void' || policy.PolicyStatus === 'Virtual Policy Void';
};

export const canVoidSelectedPolicies = (policies: SearchInventoryPoliciesResponseType[]): boolean => {
  return policies.length > 0 && policies.every(canVoidPolicy);
};

export const canUnvoidSelectedPolicies = (policies: SearchInventoryPoliciesResponseType[]): boolean => {
  return policies.length > 0 && policies.every(canUnvoidPolicy);
};

export const getPolicyType = (policy: SearchInventoryPoliciesResponseType): 'eJacket' | 'virtualPolicy' => {
  return policy.FileNo ? 'eJacket' : 'virtualPolicy';
};

// Only a non-eJacket (virtual) policy still sitting in Open inventory can be moved to another firm.
// An Assigned or Void virtual policy, and any eJacket, is out of scope for a transfer. The policy type
// is derived the same way the outbound payload derives it, so the UI and the service cannot disagree.
export const canTransferPolicy = (policy: SearchInventoryPoliciesResponseType): boolean => {
  if (getPolicyType(policy) !== 'virtualPolicy') return false;
  return policy.PolicyStatus === 'Virtual Policy Open' || policy.PolicyStatus === 'Open';
};

export const canTransferSelectedPolicies = (policies: SearchInventoryPoliciesResponseType[]): boolean => {
  return policies.length > 0 && policies.every(canTransferPolicy);
};
